export default function NotFoundPage() {
    return (
        <div
            style={{
                margin: "auto",
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
            }}
        >
            <h1>Page not found</h1>
        </div>
    );
}
